import { baseApi } from "./baseApi";

export interface SiteSettings {
  phone:         string;
  email:         string;
  address:       string;
  hoursWeekday:  string;
  hoursSaturday: string;
  hoursSupport:  string;
  whatsApp?:     string;
  mapEmbedUrl?:  string;
  facebookUrl?:  string;
  instagramUrl?: string;
  youtubeUrl?:   string;
}

const DEFAULTS: SiteSettings = {
  phone:         "+91 81828 33009",
  email:         "info@dialin24.com",
  address:       "Lucknow, Uttar Pradesh",
  hoursWeekday:  "9:00 AM - 7:00 PM",
  hoursSaturday: "9:00 AM - 5:00 PM",
  hoursSupport:  "quick response available",
};

const normalize = (raw: Record<string, unknown>): SiteSettings => ({
  phone:         String(raw.phone         ?? DEFAULTS.phone),
  email:         String(raw.email         ?? DEFAULTS.email),
  address:       String(raw.address       ?? DEFAULTS.address),
  hoursWeekday:  String(raw.hoursWeekday  ?? DEFAULTS.hoursWeekday),
  hoursSaturday: String(raw.hoursSaturday ?? DEFAULTS.hoursSaturday),
  hoursSupport:  String(raw.hoursSupport  ?? DEFAULTS.hoursSupport),
  whatsApp:      raw.whatsApp     ? String(raw.whatsApp)     : undefined,
  mapEmbedUrl:   raw.mapEmbedUrl  ? String(raw.mapEmbedUrl)  : undefined,
  facebookUrl:   raw.facebookUrl  ? String(raw.facebookUrl)  : undefined,
  instagramUrl:  raw.instagramUrl ? String(raw.instagramUrl) : undefined,
  youtubeUrl:    raw.youtubeUrl   ? String(raw.youtubeUrl)   : undefined,
});

const unwrap = (res: unknown): Record<string, unknown> => {
  const r = res as { success?: boolean; data?: unknown };
  return ((r?.data ?? res) ?? {}) as Record<string, unknown>;
};

export const siteSettingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSiteSettings: builder.query<SiteSettings, void>({
      query: () => ({ url: "/api/public/site-settings", method: "GET" }),
      transformResponse: (res: unknown) => {
        try { return normalize(unwrap(res)); } catch { return DEFAULTS; }
      },
      providesTags: [{ type: "AdminProfile" as const, id: "SITE_SETTINGS" }],
    }),

    updateSiteSettings: builder.mutation<{ success: boolean; message: string }, SiteSettings>({
      query: (body) => ({ url: "/SiteSettings", method: "PUT", body }),
      invalidatesTags: [{ type: "AdminProfile" as const, id: "SITE_SETTINGS" }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetSiteSettingsQuery, useUpdateSiteSettingsMutation } = siteSettingsApi;
export { DEFAULTS as siteSettingsDefaults };
